import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import Swal from 'sweetalert2';
import {showDuplicateLoginAlert} from '../../components/Auth/DuplicateLoginAlert';

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  try {
    return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
  } catch (error) {
    console.error('empresas:getSession decode error', {usersRt, error});
    throw error;
  }
};

const handleEmpresasError = (xhr, reject, message) => {
  if (xhr?.message === 'erro_auth') {
    showDuplicateLoginAlert();
  }

  reject([400, {message}]);
};

const normalizeEmpresasResponse = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
    normalizedValue = JSON.parse(normalizedValue);
  }

  return normalizedValue;
};

const ajaxEmpresasEvent = ({
  type,
  ll,
  dd,
  tk,
  parseType = 'base64',
  rejectMessage = 'Dados não localizados',
  extraData = {},
  routeField = 'll',
  encodeRoute = true,
  transformResponse,
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
      type,
      dataType: 'text',
      headers: {
        'Authorization': 'Bearer ' + tk,
      },
      data: {
        pp: base64_encode('emp'),
        [routeField]: encodeRoute ? base64_encode(ll) : ll,
        dd: base64_encode(JSON.stringify(dd)),
        tk,
        ...extraData,
      },
      success: function (data) {
        try {
          let responseData = normalizeEmpresasResponse(data);

          if (responseData === 'erro_auth' || responseData === 'sessao_expirada') {
            sessionStorage.clear();
            window.location.href = '/auth/login';
            return;
          }

          if (parseType === 'jsonBase64') {
            responseData = JSON.parse(base64_decode(responseData));
          } else if (parseType === 'base64') {
            responseData = base64_decode(responseData);
          }

          if (transformResponse) {
            responseData = transformResponse(responseData);
          }

          resolve([200, responseData]);
        } catch (decodeError) {
          console.error('empresas:response decode error', {type, ll, parseType, data, dd, decodeError});
          reject([400, {message: 'Resposta invalida'}]);
        }
      },
      error: function (xhr, status, error) {
        console.error('Erro AJAX:', {xhr, status, error, type, ll, dd});
        handleEmpresasError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, {message: 'Server Error'}]);
  }
});

const RestEmpresasPost = (config) => {
  const users = getSession();
  const emp = users[0];
  const uid = users[3];
  const token = users[14];
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();

  switch (caminho) {
    case 'gruposListar':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'gruposListar',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify([]))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'gruposSalvar':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'gruposSalvar',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'gruposExcluir':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'gruposExcluir',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'cadastroA3':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'cadEmpA3',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        transformResponse: (data) => ({message: data}),
      });
    case 'cadEmpresa':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'cadEmpresa',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        extraData: {stepUpToken: Arr_.stepUpToken ?? ''},
        transformResponse: (data) => ({data}),
      });
    case 'deleteEmpresa':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'deleteEmpresa',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'deleteEmpresaComDados':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'deleteEmpresaComDados',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        extraData: {stepUpToken: Arr_.stepUpToken ?? ''},
      });
    case 'editEmpresa':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'editEmpresa',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'editConfigEmpresa':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'editConfigEmpresa',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'deleteCert':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'deleteCert',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        extraData: {stepUpToken: Arr_.stepUpToken ?? ''},
      });
    case 'salvaCert':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'salvaCert',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'salvaCertA3':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'salvaCertA3',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'setFicticios':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'setFicticios',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
      });
    case 'updateCertEmpresas':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'updateCertEmpresas',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        transformResponse: (data) => ({message: data}),
      });
    case 'cadastraAtualizaCertificado':
      return new Promise(function (resolve, reject) {
        try {
          const dataPost = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dados))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'POST',
            dataType: 'text',
            headers: {
              'Authorization': 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('emp'),
              ll: base64_encode('CadastraAtualizaCertificado'),
              dd: base64_encode(JSON.stringify(dataPost)),
              tk: token,
              stepUpToken: Arr_.stepUpToken ?? '',
            },
            success: function (data) {
              try {
                const normalizedData = String(data).trim().replace(/^"|"$/g, '');
                resolve([200, {data: base64_decode(normalizedData)}]);
              } catch (decodeError) {
                console.error('empresas:cadastraAtualizaCertificado decode error', {data, decodeError});
                reject([400, {message: 'Resposta invalida'}]);
              }
            },
            error: function (xhr, status, error) {
              try {
                const normalizedResponseText = String(xhr.responseText).trim().replace(/^"|"$/g, '');
                xhr.responseText = base64_decode(normalizedResponseText);
              } catch (decodeError) {
                console.error('empresas:cadastraAtualizaCertificado error decode', {responseText: xhr.responseText, decodeError});
              }
              if (xhr.responseText === 'senha-err') {
                Swal.fire({button: 'OK', title: 'Ops', html: 'A senha do certificado está incorreta!', icon: 'info', confirmButtonColor: '#4099FF'});
              } else if (xhr.responseText === 'vencido') {
                Swal.fire({button: 'OK', title: 'Ops', html: 'O certificado selecionado está vencido!', icon: 'info', confirmButtonColor: '#4099FF'});
              } else if (xhr.responseText === 'existe') {
                Swal.fire({title: 'Ops', icon: 'info', showCancelButton: false, showConfirmButton: false, html: 'O certificado já está cadastrado!', timer: 1500});
              } else {
                Swal.fire({button: 'OK', title: 'Ops', html: 'Ocorreu um erro inesperado ao subir o certificado!<br/>Tente novamente, mais tarde!', icon: 'info', confirmButtonColor: '#4099FF'});
              }
            },
          });
        } catch (err) {
          reject([500, {message: 'Server Error'}]);
        }
      });
    case 'verificarCnpjCpfExistente':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'verificarCnpjCpfExistente',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'toggleModuloResgateXml':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'toggleModuloResgateXml',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        rejectMessage: 'Erro ao atualizar módulo',
      });
    case 'toggleModuloGestao':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'toggleModuloGestao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        rejectMessage: 'Erro ao atualizar módulo',
      });
    case 'testeCertificado':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'testarCertificado',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(JSON.parse(config.data).dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    default:
      return new Promise((resolve) => resolve([404, {message: 'Rota não encontrada'}]));
  }
};

const RestEmpresasGet = (config) => {
  const users = getSession();
  const emp = users[0];
  const uid = users[3];
  const tipoUser = users[7];
  const token = users[14];
  const caminho = config.dest.trim();

  switch (caminho) {
    case 'certsA1':
      return ajaxEmpresasEvent({
        type: 'GET',
        ll: 'certsA1',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
        parseType: 'jsonBase64',
        rejectMessage: 'erro',
      });
    case 'getEmpresas':
      return ajaxEmpresasEvent({
        type: 'GET',
        ll: 'getEmpresas',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(tipoUser))],
        tk: token,
        parseType: 'jsonBase64',
        rejectMessage: 'erro',
      });
    case 'getEmpresasCert':
      return ajaxEmpresasEvent({
        type: 'GET',
        ll: 'getEmpresasCert',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify([...(config.dataPost || []), tipoUser]))],
        tk: token,
        parseType: 'jsonBase64',
        rejectMessage: 'erro',
      });
    case 'primeiraConsulta':
      return ajaxEmpresasEvent({
        type: 'GET',
        ll: 'primeiraConsulta',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
        parseType: 'jsonBase64',
        rejectMessage: 'erro',
        routeField: 'act',
      });
    case 'tableCerts':
      return ajaxEmpresasEvent({
        type: 'GET',
        ll: 'tableCerts',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(tipoUser)],
        tk: token,
        parseType: 'jsonBase64',
        rejectMessage: 'erro',
      });
    case 'TrocaPrimeiraEmpresa':
      return new Promise(function (resolve, reject) {
        try {
          const storage = getSession();
          const dataPost = [base64_encode(emp), base64_encode(uid)];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'GET',
            dataType: 'text',
            headers: {
              'Authorization': 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('emp'),
              ll: 'trocaPrimeiraEmpresa',
              dd: base64_encode(JSON.stringify(dataPost)),
              tk: token,
            },
            success: function (data) {
              try {
                JSON.parse(base64_decode(data));
              } catch (decodeError) {
                console.error('empresas:trocaPrimeiraEmpresa decode error', {data, decodeError});
                reject([400, {message: 'Resposta invalida'}]);
                return;
              }
              storage[11] = {primeiroAcesso: false, possuiEmpresas: false};
              const cript = base64_encode(JSON.stringify(storage));
              localStorage.setItem('ddesp', cript);
              window.location.href = '/inicio/tipoTeste';
              resolve([200]);
            },
            error: function (xhr, status, error) {
              handleEmpresasError(xhr, reject, 'erro');
            },
          });
        } catch (err) {
          reject([500, {message: 'Server Error'}]);
        }
      });
    case 'vrCerts':
      return ajaxEmpresasEvent({
        type: 'GET',
        ll: 'vrCerts',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
        rejectMessage: 'erro',
      });
    case 'verificarCnpjCpfExistente':
      return ajaxEmpresasEvent({
        type: 'POST',
        ll: 'verificarCnpjCpfExistente',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(JSON.parse(config.data)))],
        tk: token,
      });
    default:
      return new Promise((resolve) => resolve([404, {message: 'Rota não encontrada'}]));
  }
};

export {RestEmpresasPost, RestEmpresasGet};
